export default __webpack_public_path__ + "static/media/debsoc.26decdc3.png";